import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { PeopleItem } from '../../shared';

class CALDAdvisoryGroup extends React.Component<any, any> {

    constructor(props, context) {
        super(props, context);
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        if (!this.props.aboutPeople || this.props.isLoading) {
            return (<div></div>);
        }

        let items = this.props.aboutPeople.filter(f => f.categoryId == 7).map((item, index) => {
            return <PeopleItem key={"people1Item" + index} {...item}></PeopleItem>;
        });

        return (<section className="base3-bg">

            <div className="container pt-2  mb-4">
                <h1>CALD ADVISORY GROUP</h1>
            </div>
            {items}
        </section>);
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        aboutPeople: state.siteData.siteData.aboutPeople,
        isLoading: state.siteData.isLoading
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {},
        dispatch
    );
};


const CALDAdvisoryGroupContainer = connect(mapStateToProps, mapDispatchToProps)(
    CALDAdvisoryGroup
);

export default CALDAdvisoryGroupContainer;


// WEBPACK FOOTER //
// ./src/components/People/CALDAdvisoryGroup.tsx